"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedShips = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const Size_1 = require("../render/Size");
const Board_1 = require("../../boards/Board");
const Resources_1 = require("../../Resources");
class RedShips extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.RED_SHIPS,
            cost: 2,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oxygen(4)),
            metadata: {
                cardNumber: 'X62',
                description: 'Requires 4% oxygen.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Gain 1 M€ for each CITY AND SPECIAL TILE adjacent to oceans, regardless of their owner.', (eb) => {
                        eb.empty().startAction.megacredits(1).slash().nbsp(Size_1.Size.TINY).cityOrSpecialTile(1).any.oceans(1).asterix();
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const board = player.game.board;
        const allCityAndSpecialTileSpaces = board.getSpacesWithSpecialTiles().concat(board.spaces.filter((space) => Board_1.Board.isCitySpace(space)));
        const eligibleTiles = allCityAndSpecialTileSpaces.filter((space) => board.getAdjacentSpaces(space).some((adjSpace) => Board_1.Board.isOceanSpace(adjSpace)));
        player.addResource(Resources_1.Resources.MEGACREDITS, eligibleTiles.length, { log: true });
        return undefined;
    }
}
exports.RedShips = RedShips;
//# sourceMappingURL=RedShips.js.map